import React from "react";
import "./Report_Analysis_Sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";

const Report_Analysis_Sidebar = () => {
  const reportAnalysis = [
    { title: "Sample Report", link: "sample-report" },
    { title: "Instrument Report", link: "instrument-report" },
    { title: "Customer Report", link: "customer-report" },
    { title: "Resource Requirement", link: "resource-requirement" },
    { title: "Process Requirement", link: "process-requirement" },
    { title: "Quality Control Plan Report", link: "quality-control-plan" },
    {
      title: "Measurement Uncertainty Report",
      link: "measurement-uncertainty-report",
    },
    { title: "Ensuring Validity Of Result", link: "validity-result" },
    { title: "Complaint Report", link: "complaint-report" },
    { title: "Non Confirming Work Report", link: "non-confirming-work" },
    { title: "Management System Requirement", link: "management-system" },
    { title: "External Audit Report", link: "external-audit-report" },
  ];

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="Report_Analysis_Sidebar common_sidemenu">
      <div className="common_white_card">
        <p className="common_section_heading">Report Analysis</p>

        <div className="menu_section">
          {reportAnalysis?.map((item) => {
            const isActive = location.pathname.includes(item.link);

            return (
              <button
                className={`menu_header ${isActive ? "active" : ""}`}
                onClick={() => {
                  navigate(item?.link);
                }}
              >
                {item?.title}
                <span className="arrow">
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Report_Analysis_Sidebar;
